import {Component, OnInit} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {AuthService} from '../../../../../firebase/src/lib/services/auth.service';
import {ChartData} from '../../../../../shared/src/lib/components/mixed-chart/mixed-chart.component';


interface YAxis {
    y0: number;
    y1: number;
    label?: string;
}

interface XAxis {
    x0: number;
    x1: number;
    label?: string;
}

interface Datum2 {
    id: string;
    xAxis: XAxis;
    yAxis: YAxis;
    labels?: any;
    segments?: any;
    data: Datum[];
}

interface Datum {
    x: number;
    y: number;
}

interface Depression {
    id: string;
    xAxis: XAxis;
    yAxis: YAxis;
    labels: any[];
    segments: number[][];
    data: any[];
}

interface Anxiety {
    id: string;
    xAxis: XAxis;
    yAxis: YAxis;
    labels: string[];
    segments: number[][];
    data: any[];
}

interface Performance {
    title?: any;
    subtitle?: any;
    score?: any;
    data: Datum2[];
}

interface Burnout {
    title: string;
}

interface DashboardRangeData {
    performance: Performance;
    anxiety: Anxiety;
    depression: Depression;
    burnout: Burnout;
    important_parameters: Burnout;
    details: Burnout;
    recommendations: Burnout;
}

interface DashboardData {
    date: Date;
    month: DashboardRangeData;
}

@Component({
    selector: 'app-test',
    templateUrl: './test.component.html',
    styleUrls: ['./test.component.scss']
})
export class TestComponent implements OnInit {

    barValues = [
        {
            barTitle: 'Dysphoric Bias',
            values: [10, 12, 30]
        },
        {
            barTitle: 'Anhedonic Bias',
            values: [10, 20, 60]
        },
        {
            barTitle: 'Hypervigilance',
            values: [10, 20, 10]
        },
        {
            barTitle: 'Avoidance',
            values: [10, 80, 30]
        },
        {
            barTitle: 'Risk of Depression',
            values: [10, 50, 30]
        },
        {
            barTitle: 'Risk of Anxiety Disorder',
            values: [10, 20, 30]
        },
        {
            barTitle: 'Trouble with sleeping',
            values: [10, 20, 30]
        },
        {
            barTitle: 'Trouble completing my tasks',
            values: [40, 20, 10]
        },
        {
            barTitle: 'Easily irritable',
            values: [10, 20, 30]
        },
        {
            barTitle: 'I have anger issues',
            values: [10, 30, 30]
        },
        {
            barTitle: 'I hate myself',
            values: [50, 20, 30]
        }
    ];

    mixedChartData: ChartData[] = [];

    xAxis: XAxis = {
        x0: 0,
        x1: 1
    };
    yAxis: YAxis = {
        y0: 0,
        y1: 1
    };

    anxietySegments: any[] = [];
    depressionSegments: any[] = [];

    constructor(
        private http: HttpClient,
        private auth: AuthService,
    ) {
    }

    ngOnInit(): void {
        this.getData();
    }

    getData() {
        const headers = new HttpHeaders({
            Authorization: `Bearer ${this.auth.userData?.stsTokenManager?.accessToken}`
        });
        this.http.get(`${environment.apiUrl}/dashboard/company`, {
            headers
        })
            .subscribe((res: any) => {
                this.generateMixedChartData(res);
                this.generateAnxietyData(res);
                this.generateDepressionData(res);
            });

    }

    generateAnxietyData(data: any) {
        const s = 'year';
        this.anxietySegments = data[s].anxiety.segments;
    }

    generateDepressionData(data: any) {
        const s = 'year';
        this.depressionSegments = data[s].depression.segments;
    }

    generateMixedChartData(data) {
        this.mixedChartData = this.mapPerformanceData(data);
    }

    mapPerformanceData(data: DashboardData): ChartData[] {
        const s = 'year';
        const arr: ChartData[] = [];
        const {xAxis, yAxis} = data[s].performance.data.find((el => el.id === 'Ukraine'));
        this.xAxis = xAxis;
        this.yAxis = yAxis;
        const barArray = data[s].performance.data.find((el => el.id === 'Ukraine'))
            .data.map((el) => {
                return {
                    x: el.x,
                    yBar: el.y
                };
            })
        ;
        const colorArray = data[s].performance.data.find((el => el.id === 'test'))
            .data.map((el) => {
                return {
                    x: el.x,
                    yColorLine: el.y
                };
            });
        const greyArray = data.month.performance.data.find((el => el.id === 'Ukraine'))
            .data.map((el) => {
                return {
                    x: el.x,
                    yGreyLine: el.y
                };
            });
        const map = new Map();
        barArray.forEach(item => map.set(item.x, item));
        colorArray.forEach(item => map.set(item.x, {...map.get(item.x), ...item}));
        greyArray.forEach(item => map.set(item.x, {...map.get(item.x), ...item}));

        const mergedArr = Array.from(map.values());
        return mergedArr;
    }

}
